var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2810_362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 10,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66275 10.3654C7.65567 10.359 7.64873 10.3525 7.64194 10.3457C7.63623 10.34 7.63068 10.3342 7.62531 10.3283L3.64727 6.35031C3.452 6.15505 3.45224 5.83871 3.6478 5.64375C3.84336 5.44878 4.16019 5.44902 4.35545 5.64428L7.99699 9.28578L11.6476 5.64664C11.8432 5.45169 12.1601 5.45182 12.3555 5.64693C12.5509 5.84203 12.5508 6.15824 12.3553 6.3532L8.42685 10.2693C8.40757 10.2994 8.38474 10.3279 8.35835 10.3542C8.16676 10.5452 7.85878 10.5489 7.66275 10.3654Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2810_362)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownThin);
export default __webpack_public_path__ + "static/media/chevron-down-thin.5c318f026cfb9aa0e3f161cff1f18c21.svg";
export { ForwardRef as ReactComponent };